<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
       <!-- Content Header (Page header) -->
        <section class="content-header">
            <!-- <h1>Toko<small>It's all start from here <i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1> -->
            <ol class="breadcrumb">
                <li><router-link to="/"> <i class="ti-home"></i></router-link></li>
                <li><router-link to="/toko">Toko</router-link></li>
                <li><a href="#">Pengeluaran Bulanan</a></li>
                <li class="active">Pengeluaran Bulanan</li>
            </ol>
        </section>
  
            <!-- Main content -->
            <section class="content">
               <!-- Basic Tables-->
               <h4>{{ cari }}</h4>

            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="SUMMARY" name="summary">

                  <div class="box">
                    <div class="box-header with-border">
                        <div class="pull-right">
                            Sort by &nbsp;
                            <el-select @change='handleFilter' style="width: 200px" class="filter-item" v-model="sort">
                              <el-option v-for="item in sortOptions" :key="item.key" :label="item.label" :value="item.key">
                              </el-option>
                            </el-select><!-- 
                            Sort by &nbsp;
                            <el-select @change='handleFilter' style="width: 200px" class="filter-item" v-model="listQuery.sort">
                              <el-option v-for="item in sortOptions" :key="item.key" :label="item.label" :value="item.key">
                              </el-option>
                            </el-select> -->
                            <!-- <el-button type="success" @click="addData2()">Tambah Data</el-button> -->
                        </div>
                    </div>
                    <div class="box-body">
                          <el-table v-loading="loadingModal3"
                          :data="tableData6"
                          style="width: 100%" responsive>
                          <el-table-column fixed="left"
                            label="Bulan"
                            prop="bulan"
                            min-width="100">
                            <template slot-scope="scope">
                              <span>{{ scope.row.bulan + ' - ' + scope.row.tahun }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="Jumlah"
                            prop="amount"
                            min-width="150">
                            <template slot-scope="scope">
                              <span>{{ toMoney(scope.row.amount) }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column label="Pilihan" align="right" header-align="right" width="150">
                            <template slot-scope="scope">
                              <el-tooltip class="item" effect="dark" content="Detail" placement="top-start">
                                <el-button type="primary" size="small" icon="ti-eye"  @click="confirmDet2(scope.row)"></el-button>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                        </el-table>

                      <br/>

                        <div align="right">
                          <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="tableData5.length"
                            :page-size="page_size"
                            :current-page="current_page2"
                            @current-change="handleCurrentChange2" >
                          </el-pagination>
                        </div>


                    </div>
                </div>

                <el-dialog :title="title1" :visible.sync="dialogSumDet" v-loading="loadingModalSumDet">
                    <el-table
                          :data="tableData8"
                          style="width: 100%" responsive>
                          <el-table-column
                            label="Jenis"
                            prop="jenis"
                            min-width="200">
                          </el-table-column>
                          <el-table-column
                            label="Jumlah"
                            prop="amount"
                            min-width="150">
                            <template slot-scope="scope">
                              <span>{{ toMoney(scope.row.amount) }}</span>
                            </template>
                          </el-table-column>
                        </el-table>
                </el-dialog>

              </el-tab-pane>
              <el-tab-pane label="COGS " name="cogs">

                <div class="box">
                    <div class="box-header with-border">
                          <div class="pull-right">
                            Sort by &nbsp;
                            <el-select @change='handleFilter1' style="width: 200px" class="filter-item" v-model="sort1">
                              <el-option v-for="item in sortOptions1" :key="item.key" :label="item.label" :value="item.key">
                              </el-option>
                            </el-select>
                              <el-button type="success" @click="tambahData()">Tambah Data</el-button>                            
                          </div>
                      </el-row>
                        <!-- <div class="pull-right"> -->
                          <!-- <el-select style="width: 200px;" v-model="kode_wilayah" placeholder="Pilih Wilayah">
                            <el-option
                              v-for="item in wilayah1"
                              :key="item.kode"
                              :label="item.nama"
                              :value="item.kode">
                            </el-option>
                          </el-select>
                            <el-button class="filter-item" type="primary" v-waves icon="el-icon-search" @click="getData1(kode_wilayah)">Cari</el-button> -->
                              <!-- <el-button type="success" @click="tambahData()">Tambah Data</el-button>                            
                        </div> -->
                    </div>
                    <div class="box-body">
                          <el-table v-loading="loadingModal"
                          :data="tableData2"
                          style="width: 100%" responsive>
                          <el-table-column fixed="left"
                            label="Nomor Invoice"
                            min-width="200"
                            prop="nomor_invoice">
                          </el-table-column>
                          <el-table-column
                            label="Tanggal Pengiriman"
                            min-width="200"
                            prop="tanggal_pengiriman">
                          </el-table-column>
                          <el-table-column
                            label="Subtotal"
                            min-width="150"
                            prop="subtotal" align="right" header-align="right">
                            <template slot-scope="scope">
                              <span>{{ toMoney(scope.row.subtotal) }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="PPN"
                            min-width="150"
                            prop="ppn" align="right" header-align="right">
                            <template slot-scope="scope">
                              <span>{{ toMoney(scope.row.ppn) }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="Total"
                            min-width="150"
                            prop="total" align="right" header-align="right">
                            <template slot-scope="scope">
                              <span>{{ toMoney(scope.row.total) }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="Total Item"
                            min-width="100"
                            prop="item_total" align="right" header-align="right">
                          </el-table-column>
                          <el-table-column label="Pilihan" align="right" header-align="right"
                            width="150">
                            <template slot-scope="scope">
                              <el-tooltip v-if="!scope.row.edit && !scope.row.add" class="item" effect="dark" content="Detail" placement="top-start">
                                <el-button type="primary" size="small" icon="ti-eye" @click="confirmDet(scope.row)"></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="!scope.row.add" class="item" effect="dark" content="Hapus Invoice" placement="top-start">
                                <el-button type="danger" size="small" icon="el-icon-delete" @click="confirmDel(scope.row)"></el-button>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                        </el-table>

                      <br/>

                        <div align="right">
                          <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="tableData.length"
                            :page-size="page_size"
                            :current-page="current_page"
                            @current-change="handleCurrentChange" >
                          </el-pagination>
                        </div>


                    </div>
                </div>

                <el-dialog :title="nomor_invoice" :visible.sync="dialogFormPrintVisible" v-loading="loadingModalPrint">
                    <el-table v-loading="loadingModal1"
                      :data="tableData1"
                      style="width: 100%" responsive>
                      <el-table-column
                        label="NO"
                        prop="no"
                        width="50">
                      </el-table-column>
                      <el-table-column
                        label="Nama"
                        prop="nama">
                      </el-table-column>
                      <el-table-column
                        label="Qty">
                        <template slot-scope="scope">
                          {{ scope.row.qty }} {{ scope.row.satuan }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Price Unit"
                        prop="price_unit" align="right" header-align="right">
                        <template slot-scope="scope">
                          <span>{{ toMoney(scope.row.price_unit) }}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                        label="Price Total"
                        prop="price_total" align="right" header-align="right">
                        <template slot-scope="scope">
                          <span>{{ toMoney(scope.row.price_total) }}</span>
                        </template>
                      </el-table-column>
                    </el-table>
                    <span slot="footer" class="dialog-footer">
                      <el-button type="primary" @click="print()">Print</el-button>
                    </span>
                </el-dialog>

                <el-dialog title="Tambah Invoice" :visible.sync="dialogFormVisible" v-loading="loadingModalAdd">
                  <el-form :model="form_" status-icon ref="form_" :rules="rules" :label-width="formLabelWidth">
                    <el-form-item label="Nomor Invoice" prop="nomor_invoice">
                      <el-input type="text" v-model="form_.nomor_invoice"></el-input>
                    </el-form-item>
                    <el-form-item label="Tanggal Invoice" prop="tanggal_invoice">
                      <el-date-picker
                        v-model="tanggal_invoice"
                        type="date">
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="Tanggal Pengiriman" prop="tanggal_pengiriman">
                      <el-date-picker
                        v-model="tanggal_pengiriman"
                        type="date">
                      </el-date-picker>
                    </el-form-item>
                  </el-form>
                  <div class="pull-right">
                    <el-button type="success" @click="addData1()" size="mini">Tambah Item</el-button>
                  </div>
                  <el-table v-loading="loadingModal"
                          :data="tableData1"
                          style="width: 100%" responsive>
                          <el-table-column fixed="left"
                            label="Barang"
                            min-width="300">
                            <template slot-scope="scope">
                              <template v-if="scope.row.add">
                                <el-select v-model="scope.row.kode_barang" placeholder="Pilih Barang">
                                  <el-option
                                    v-for="item in wilayah"
                                    :key="item.kode_barang"
                                    :label="item.nama"
                                    :value="item.kode_barang">
                                  </el-option>
                                </el-select>
                              </template>
                              <span v-else>{{ scope.row.nama_barang }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="Qty"
                            min-width="200">
                            <template slot-scope="scope">
                              <template v-if="scope.row.add">
                                <el-input class="edit-input" size="small" v-model="scope.row.qty" @change="priceChange(scope.$index, scope.row)"></el-input>
                              </template>
                              <span v-else>{{ scope.row.qty }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="Price Unit"
                            min-width="250">
                            <template slot-scope="scope">
                              <template v-if="scope.row.add">
                                <el-input class="edit-input" size="small" v-model="scope.row.price_unit" @change="priceChange(scope.$index, scope.row)"></el-input>
                              </template>
                              <span v-else>{{ scope.row.price_unit }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="Price Total"
                            min-width="250"
                            prop="price_total">
                          </el-table-column>
                          <el-table-column label="Pilihan" align="right" header-align="right"
                            width="200">
                            <template slot-scope="scope">
                              <el-tooltip v-if="!scope.row.add" class="item" effect="dark" content="Edit Ingredient" placement="top-start">
                                <el-button type="primary" size="small" icon="el-icon-edit" @click="confirmEdit2(scope.$index, scope.row)"></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="!scope.row.add" class="item" effect="dark" content="Hapus Ingredient" placement="top-start">
                                <el-button type="danger" size="small" icon="el-icon-delete" @click="confirmDel(scope.$index, scope.row)"></el-button>
                              </el-tooltip>
                              <!-- <el-tooltip v-if="scope.row.add" class="item" effect="dark" content="Ok" placement="top-start">
                                <el-button size="small" icon="el-icon-check" type="success" @click="confirmAdd1(scope.row)"></el-button>
                              </el-tooltip> -->
                              <el-tooltip v-if="scope.row.add" class="item" effect="dark" content="Cancel" placement="top-start">
                                <el-button size="small" icon="el-icon-error" type="warning" @click="cancelEdit(scope.$index, scope.row)"></el-button>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                        </el-table>
                        <br/>
                        <el-row>
                          <el-col :span="6">SUBTOTAL</el-col>
                          <el-col :span="6">: {{ subtotal }}</el-col>
                          <el-col :span="6">PPN</el-col>
                          <el-col :span="6">: {{ ppn }}</el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="6">&nbsp;</el-col>
                          <el-col :span="6">&nbsp;</el-col>
                          <el-col :span="6">TOTAL</el-col>
                          <el-col :span="6">: {{ total_inv }}</el-col>
                        </el-row>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormVisible = false">Cancel</el-button>
                      <el-button type="primary" @click="confirmAdd('form_')">Submit</el-button>
                    </span>
                </el-dialog>

                <!-- <el-dialog title="Tambah Wilayah" :visible.sync="dialogFormVisible" v-loading="loadingModalAdd">
                  <el-form :model="form" status-icon :rules="rules" ref="form" label-width="120px" class="demo-ruleForm">
                    <el-form-item label="Name" prop="name">
                      <el-input type="text" v-model="form.name" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="confirmAdd('form')">Submit</el-button>
                    </el-form-item>
                  </el-form>
                </el-dialog> -->

                <el-dialog title="Edit Area" :visible.sync="dialogFormWilEdit" v-loading="loadingModalEdit">
                  <el-form :model="form1" status-icon :rules="rules" ref="form1" :label-width="formLabelWidth" class="demo-ruleForm">
                    <el-form-item label="Kode" :label-width="formLabelWidth">
                      <el-input v-model="form1.kode" auto-complete="off" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="Nama" prop="name" :label-width="formLabelWidth">
                      <el-input type="text" v-model="form1.name" auto-complete="off"></el-input>
                    </el-form-item>
                  </el-form>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormWilEdit = false">Cancel</el-button>
                    <el-button type="primary" @click="confirmEdit1('form1')">Confirm</el-button>
                  </span>
                </el-dialog>

                <el-dialog title="Tambah Toko" :visible.sync="dialogFormArea" v-loading="loadingModalArea">
                  <el-form :model="form2" status-icon :rules="rules2" ref="form2" :label-width="formLabelWidth" class="demo-ruleForm">
                    <el-form-item label="Area" :label-width="formLabelWidth">
                      <el-input v-model="form2.name" auto-complete="off" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="Nama Toko" prop="toko" :label-width="formLabelWidth">
                      <el-input type="text" v-model="form2.toko" auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="Alamat Toko" prop="alamat_toko" :label-width="formLabelWidth">
                      <el-input type="text" v-model="form2.alamat_toko" auto-complete="off"></el-input>
                    </el-form-item>
                  </el-form>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="loadingModalArea = false">Cancel</el-button>
                    <el-button type="primary" @click="confirmArea1('form2')">Confirm</el-button>
                  </span>
                </el-dialog>


                <el-dialog title="Konfirmasi" :visible.sync="dialogFormWilDel" v-loading="loadingModalDel">
                  <h4>Apakah Anda yakin akan menghapus invoice pengeluaran bulanan COGS dengan nomor {{ nama }} ?</h4>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormWilDel = false">Cancel</el-button>
                    <el-button type="primary" @click="confirmDel1()">Confirm</el-button>
                  </span>
                </el-dialog>

                <el-dialog title="Info" :visible.sync="dialogFormInfo">
                  <h5>{{message}}</h5>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormInfo = false">Cancel</el-button>
                    <el-button type="primary" @click="dialogFormInfo = false">OK</el-button>
                  </span>
                </el-dialog>

              </el-tab-pane>
              <el-tab-pane label="OPERASIONAL" name="operasional">

                 <div class="box">
                    <div class="box-header with-border">
                        <div class="pull-right">
                            Sort by &nbsp;
                            <el-select @change='handleFilter2' style="width: 200px" class="filter-item" v-model="sort2">
                              <el-option v-for="item in sortOptions" :key="item.key" :label="item.label" :value="item.key">
                              </el-option>
                            </el-select><!-- 
                            Sort by &nbsp;
                            <el-select @change='handleFilter' style="width: 200px" class="filter-item" v-model="listQuery.sort">
                              <el-option v-for="item in sortOptions" :key="item.key" :label="item.label" :value="item.key">
                              </el-option>
                            </el-select> -->
                            <el-button type="success" @click="addData2()">Tambah Data</el-button>
                        </div>
                    </div>
                    <div class="box-body">
                          <el-table v-loading="loadingModal3"
                          :data="tableData4"
                          style="width: 100%" responsive>
                          <el-table-column fixed="left"
                            label="Bulan"
                            prop="nama"
                            min-width="200">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <!-- <el-input class="edit-input" size="small" v-model="scope.row.nama"></el-input> -->
                                <el-form :model="scope.row" :rules="rules3" :ref="('form' + scope.$index)" class="demo-ruleForm">
                                  <el-form-item prop="bulan">
                                    <el-date-picker
                                      v-model="value4"
                                      type="month"
                                      placeholder="Pilih bulan">
                                    </el-date-picker>
                                  </el-form-item>
                                </el-form>
                              </template>
                              <span v-else>{{ scope.row.bulan + ' - ' + scope.row.tahun}}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="Nama"
                            prop="nama"
                            min-width="200">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <!-- <el-input class="edit-input" size="small" v-model="scope.row.nama"></el-input> -->
                                <el-form :model="scope.row" :rules="rules3" :ref="('form' + scope.$index)" class="demo-ruleForm">
                                  <el-form-item prop="nama">
                                    <el-select v-model="scope.row.nama" placeholder="Pilih Pengeluaran">
                                      <el-option
                                        v-for="item in pengbulpil"
                                        :key="item.kode"
                                        :label="item.nama"
                                        :value="item.nama">
                                      </el-option>
                                    </el-select>
                                  </el-form-item>
                                </el-form>
                              </template>
                              <span v-else>{{ scope.row.nama }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="Jumlah"
                            prop="jumlah"
                            min-width="300">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <!-- <el-input class="edit-input" size="small" v-model="scope.row.jumlah"></el-input> -->
                                <el-form :model="scope.row" :rules="rules3" :ref="('form' + scope.$index)" class="demo-ruleForm">
                                  <el-form-item prop="jumlah">
                                    <el-input v-model="scope.row.jumlah"></el-input>
                                  </el-form-item>
                                </el-form>
                              </template>
                              <span v-else>{{ toMoney(scope.row.amount) }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column label="Pilihan" align="right" header-align="right" width="150">
                            <template slot-scope="scope">
                              <el-tooltip v-if="scope.row.edit" class="item" effect="dark" content="Ok" placement="top-start">
                                <el-button type="success" size="small" icon="el-icon-check"  @click="confirmEdit3(scope.$index, scope.row, ('form' + scope.$index))"></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="scope.row.edit" class="item" effect="dark" content="Cancel" placement="top-start">
                                <el-button size="small" icon="el-icon-error" type="warning" @click="cancelEdit1(scope.$index, scope.row)"></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Detail" placement="top-start">
                                <el-button type="primary" size="small" icon="ti-eye"  @click="confirmDet1(scope.row)"></el-button>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                        </el-table>

                      <br/>

                        <div align="right">
                          <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="tableData3.length"
                            :page-size="page_size"
                            :current-page="current_page1"
                            @current-change="handleCurrentChange1" >
                          </el-pagination>
                        </div>


                    </div>
                </div>

                <el-dialog title="Konfirmasi" :visible.sync="dialogFormWilDel1" v-loading="loadingModalDel1">
                  <h4>Apakah Anda yakin akan menghapus {{ nama }} ?</h4>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormWilDel1 = false">Batal</el-button>
                    <el-button type="primary" @click="confirmDel2()">Ya</el-button>
                  </span>
                </el-dialog>


                <el-dialog title="Info" :visible.sync="dialogFormInfo">
                  <h5>{{message}}</h5>
                  <span slot="footer" class="dialog-footer">
                    <!-- <el-button @click="dialogFormInfo = false">Cancel</el-button> -->
                    <el-button type="primary" @click="dialogFormInfo = false">OK</el-button>
                  </span>
                </el-dialog>



                <el-dialog :title="title" :visible.sync="dialogOprDet" v-loading="loadingModalOprDet">
                    <el-table
                          :data="tableData7"
                          style="width: 100%" responsive>
                          <el-table-column
                            label="Nama"
                            prop="nama"
                            min-width="200">
                          </el-table-column>
                          <el-table-column
                            label="Jumlah"
                            prop="amount"
                            min-width="200">
                            <template slot-scope="scope">
                              <span>{{ toMoney(scope.row.amount) }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column label="Pilihan" align="right" header-align="right" width="150" fixed="right">
                            <template slot-scope="scope">
                              <el-tooltip class="item" effect="dark" content="Hapus" placement="top-start">
                                <el-button type="danger" size="small" icon="el-icon-delete"  @click="confirmDel_(scope.row)"></el-button>
                              </el-tooltip>
                            </template>
                          </el-table-column>
                        </el-table>
                </el-dialog>


              </el-tab-pane>
            </el-tabs>

                <!-- <el-dialog title="Loading" size="sm" centered hide-footer hide-header class="modal-info" :no-close-on-backdrop='true' :no-close-on-esc='true' :visible.sync="loadingModal" stye="width: 10%; display: flex; min-height: calc(100vh - 60px); flex-direction: column; justify-content: center; overflow: auto;">
                  <b-container fluid>
                    <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
                  </b-container>
                </el-dialog> -->


                <!-- End of Basic Tables-->
                
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
    import Vue from 'vue'
    import VueResource from 'vue-resource'
    import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

    import jsonUrl from '../../../assets/url.json'
    import VueCookie from 'vue-cookie'
    import moment from 'moment'
    Vue.use(VueCookie)

    Vue.use(VueResource)

    export default {
      name: 'SimpleTable',
      components: {
        ClipLoader
      },
      data: function () {
        var validateName = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nomor invoice'))
          } else {
            callback()
          }
        }
        var validateToko = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama toko'))
          } else {
            callback()
          }
        }
        var validateAlamatToko = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi alamat toko'))
          } else {
            callback()
          }
        }
        var validateWil = (rule, value, callback) => {
          console.log('val wil ' + value)
          if (value === '') {
            callback(new Error('Silahkan pilih wilayah'))
          } else {
            callback()
          }
        }
        return {
          sort: 'none',
          sortOptions: [{ label: '--', key: 'none' }, { label: 'Bulan Terendah', key: '+bulan' }, { label: 'Bulan Tertinggi', key: '-bulan' }, { label: 'Jumlah Terendah', key: '+jumlah' }, { label: 'Jumlah Tertinggi', key: '-jumlah' }],
          sort1: 'none',
          sort2: 'none',
          sortOptions1: [{ label: '--', key: 'none' }, { label: 'Nomor Invoice Terendah', key: '+invoice' }, { label: 'Nomor Invoice Tertinggi', key: '-invoice' }, { label: 'Tanggal Terendah', key: '+tanggal' }, { label: 'Tanggal Tertinggi', key: '-tanggal' }, { label: 'Total Terendah', key: '+total' }, { label: 'Total Tertinggi', key: '-total' }],
          value4: new Date(),
          activeName: 'summary',
          struk: '',
          nomor_invoice: '',
          tanggal_invoice: new Date(),
          tanggal_pengiriman: new Date(),
          subtotal: 0,
          ppn: 0,
          total_inv: 0,
          stok_wilayah: '',
          stok_tanggal: '',
          stok_area: '',
          stok_nomor: '',
          stok_toko: '',
          stok_dibuat_oleh: '',
          tableData: [],
          tableData1: [],
          tableData2: [],
          tableData3: [],
          tableData4: [],
          tableData5: [],
          tableData6: [],
          tableData7: [],
          tableData8: [],
          pengbulpil: [],
          total: null,
          page_size: 10,
          current_page: 1,
          current_page1: 1,
          current_page2: 1,
          wilayah: [],
          wilayah1: [],
          kode_wilayah: '%',
          kode_toko: '',
          wil: '',
          cari: '',
          title: '',
          title1: '',
          rules: {
            nomor_invoice: [
              { required: true, message: 'Silahkan isi Nomor Invoive', trigger: 'blur' }
            ]
          },
          rules1: {
            name: [
              { validator: validateName, trigger: 'blur' }
            ],
            kode_wilayah: [
              { validator: validateWil, trigger: 'change' }
            ]
          },
          rules2: {
            toko: [
              { validator: validateToko, trigger: 'blur' }
            ],
            alamat_toko: [
              { validator: validateAlamatToko, trigger: 'blur' }
            ]
          },
          dialogFormVisible: false,
          dialogFormWilEdit: false,
          dialogFormWilDel: false,
          dialogFormWilDel1: false,
          dialogFormArea: false,
          loadingModal: false,
          loadingModal1: false,
          loadingModal3: false,
          loadingModalAdd: false,
          loadingModalEdit: false,
          loadingModalTambah: false,
          loadingModalDel: false,
          loadingModalDel1: false,
          dialogFormInfo: false,
          dialogFormPrintVisible: false,
          loadingModalPrint: false,
          dialogOprDet: false,
          loadingModalOprDet: false,
          dialogSumDet: false,
          loadingModalSumDet: false,
          form: {
            kode: '',
            name: '',
            kode_wilayah: '',
            wilayah: '',
            date1: '',
            date2: '',
            delivery: false,
            type: [],
            resource: '',
            desc: ''
          },
          form1: {
            kode: '',
            bulan: '',
            tahun: '',
            nama: '',
            jumlah: '',
            name: '',
            kode_wilayah: ''
          },
          form2: {
            kode: '',
            name: '',
            toko: '',
            alamat_toko: ''
          },
          message: '',
          formLabelWidth: '200px',
          rules3: {
            nama: [
              { required: true, message: 'Silahkan isi nama area', trigger: 'blur' }
            ],
            kode_wilayah: [
              { required: true, message: 'Silahkan pilih wilayah', trigger: 'change' }
            ]
          },
          form_: {
            nomor_invoice: ''
          },
          form_opr: {
            nama: '',
            jumlah: '',
            bulan: '',
            tahun: ''
          },
          nama: ''
        }
      },
      methods: {
        toMoney (x) {
          return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        },
        handleFilter: function () {
          var byNama = this.tableData5.slice(0)
          if (this.sort === '+bulan') {
            byNama.sort(function (a, b) {
              var x = new Date(a.tahun + '-' + a.bulan).getTime()
              var y = new Date(b.tahun + '-' + b.bulan).getTime()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else if (this.sort === '-bulan') {
            byNama.sort(function (a, b) {
              var x = new Date(b.tahun + '-' + b.bulan).getTime()
              var y = new Date(a.tahun + '-' + a.bulan).getTime()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else if (this.sort === '+jumlah') {
            byNama.sort(function (a, b) {
              return a.amount - b.amount
            })
          } else if (this.sort === '-jumlah') {
            byNama.sort(function (a, b) {
              return b.amount - a.amount
            })
          } else {
            byNama = this.tableData5.slice(0)
          }
          this.tableData5 = byNama.slice()
          this.handleCurrentChange2(this.current_page2)
        },
        handleFilter2: function () {
          var byNama = this.tableData3.slice(0)
          if (this.sort2 === '+bulan') {
            byNama.sort(function (a, b) {
              var x = new Date(a.tahun + '-' + a.bulan).getTime()
              var y = new Date(b.tahun + '-' + b.bulan).getTime()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else if (this.sort2 === '-bulan') {
            byNama.sort(function (a, b) {
              var x = new Date(b.tahun + '-' + b.bulan).getTime()
              var y = new Date(a.tahun + '-' + a.bulan).getTime()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else if (this.sort2 === '+jumlah') {
            byNama.sort(function (a, b) {
              return a.amount - b.amount
            })
          } else if (this.sort2 === '-jumlah') {
            byNama.sort(function (a, b) {
              return b.amount - a.amount
            })
          } else {
            byNama = this.tableData3.slice(0)
          }
          this.tableData3 = byNama.slice()
          this.handleCurrentChange1(this.current_page1)
        },
        handleFilter1: function () {
          var byNama = this.tableData.slice(0)
          if (this.sort1 === '+tanggal') {
            byNama.sort(function (a, b) {
              var x = new Date(a.tanggal_pengiriman).getTime()
              var y = new Date(b.tanggal_pengiriman).getTime()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else if (this.sort1 === '-tanggal') {
            byNama.sort(function (a, b) {
              var x = new Date(b.tanggal_pengiriman).getTime()
              var y = new Date(a.tanggal_pengiriman).getTime()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else if (this.sort1 === '+total') {
            byNama.sort(function (a, b) {
              return a.total - b.total
            })
          } else if (this.sort1 === '-total') {
            byNama.sort(function (a, b) {
              return b.total - a.total
            })
          } else if (this.sort1 === '+invoice') {
            byNama.sort(function (a, b) {
              var x = a.nomor_invoice.toLowerCase()
              var y = b.nomor_invoice.toLowerCase()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else if (this.sort1 === '-invoice') {
            byNama.sort(function (a, b) {
              var x = b.nomor_invoice.toLowerCase()
              var y = a.nomor_invoice.toLowerCase()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else {
            byNama = this.tableData.slice(0)
          }
          this.tableData = byNama.slice()
          this.handleCurrentChange(this.current_page2)
        },
        confirmEdit3: function (j, row, formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.loadingModal3 = true

              var tgl = moment(this.value4).format('MM')
              var tgl1 = moment(this.value4).format('YYYY')
              var req = {kode_toko: this.kode_toko, nama: row.nama, bulan: tgl, tahun: tgl1, jumlah: row.jumlah}
              var req1 = JSON.stringify(req)

              var url = Vue.cookie.get('url') + '/' + jsonUrl.invoice1 + '/create'

              Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
                // console.log('response ' + JSON.stringify(response.body))
                // if (response.body.status === "SUCCESS") {}
                if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
                  this.$router.push('/login')
                } else {
                  this.dialogFormVisible = false
                  this.loadingModal3 = false
                  this.getDataOpr()
                  this.message = response.body
                  this.dialogFormInfo = true
                  this.clearForm()
                }
              }, response => {
                // error callback
                this.dialogFormVisible = false
                this.loadingModal3 = false
                this.clearForm()
              })
            } else {
              return false
            }
          })
        },
        handleClick (tab, event) {
          console.log(tab, event)
        },
        tambahData: function () {
          this.clearForm()
          this.dialogFormVisible = true
          this.tableData1 = []
        },
        priceChange: function (j, row) {
          row.price_total = row.qty * row.price_unit
          this.$set(this.tableData1, j, row)
          this.subtotal = 0
          this.ppn = 0
          this.total_inv = 0
          for (var i = 0; i < this.tableData1.length; i++) {
            this.subtotal += this.tableData1[i].price_total
          }
          this.ppn = (this.subtotal * 0.1).toFixed(2)
          this.total_inv = (this.subtotal * 1.1).toFixed(2)
        },
        changeBarang: function (j, row) {
          for (var i = 0; i < this.wilayah.length; i++) {
            if (this.wilayah[i].kode === row.kode_barang) {
              console.log(this.wilayah[i])
              row.price_unit = this.wilayah[i].price_unit
              row.price_total = this.wilayah[i].price_total
              this.$set(this.tableData1, j, row)
              break
            }
          }
        },
        handleCurrentChange: function (val) {
          this.current_page = val
          this.tableData2 = []
          var a = (this.current_page - 1) * this.page_size
          var b = a + this.page_size
          if (b > this.tableData.length) {
            b = this.tableData.length
          }
          for (var i = a; i < b; i++) {
            this.tableData2.push(this.tableData[i])
          }
        },
        handleCurrentChange1: function (val) {
          this.current_page1 = val
          this.tableData4 = []
          var a = (this.current_page1 - 1) * this.page_size
          var b = a + this.page_size
          if (b > this.tableData3.length) {
            b = this.tableData3.length
          }
          for (var i = a; i < b; i++) {
            this.tableData4.push(this.tableData3[i])
          }
        },
        handleCurrentChange2: function (val) {
          this.current_page2 = val
          this.tableData6 = []
          var a = (this.current_page2 - 1) * this.page_size
          var b = a + this.page_size
          if (b > this.tableData5.length) {
            b = this.tableData5.length
          }
          for (var i = a; i < b; i++) {
            this.tableData6.push(this.tableData5[i])
          }
        },
        addData: function () {
          this.tableData2.unshift({kode: '', nama: '', edit: false, add: true, wilayah: '', kode_wilayah: ''})
        },
        addData1: function () {
          this.tableData1.unshift({kode_barang: '', nama: '', edit: false, add: true, qty: 0, price_unit: 0, price_total: 0})
        },
        addData2: function () {
          this.tableData4.unshift({kode: '', nama: '', jumlah: '', bulan: '', tahun: '', edit: true, add: true})
        },
        confirmArea: function (row) {
          this.form2.kode = row.kode
          this.form2.name = row.nama
          this.dialogFormArea = true
        },
        confirmArea1: function (formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.loadingModalArea = true
              var req = {kode_area: this.form2.kode, nama: this.form2.toko, alamat: this.form2.alamat_toko}
              var req1 = JSON.stringify(req)

              var url = Vue.cookie.get('url') + '/' + 'toko' + '/create'

              Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
                // console.log('response ' + JSON.stringify(response.body))
                // if (response.body.status === "SUCCESS") {}
                if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
                  this.$router.push('/login')
                } else {
                  this.dialogFormArea = false
                  // this.getData()
                  this.loadingModalArea = false
                  // this.clearForm()
                  this.message = response.body
                  this.dialogFormInfo = true
                }
              }, response => {
                // error callback
                this.dialogFormArea = false
                this.loadingModalArea = false
                // this.clearForm()
              })
            } else {
              return false
            }
          })
        },
        clearForm: function () {
          this.form_.nomor_invoice = ''
          this.tanggal_invoice = new Date()
          this.tanggal_pengiriman = new Date()
          this.subtotal = 0
          this.ppn = 0
          this.total_inv = 0
        },
        cancelEdit: function (j, row) {
          // if (row.kode !== '') {
          //   row.nama = row.nama1
          //   var item = this.tableData1[j]
          //   item.edit = false
          //   item.add = false
          //   this.$set(this.tableData1, j, item)
          // } else {
          this.tableData1.splice(j, 1)
          this.priceChange()
          // }
        },
        cancelEdit1: function (j, row) {
          if (row.kode !== '') {
            row.nama = row.nama1
            row.jumlah = row.jumlah1
            row.bulan = row.bulan1
            row.tahun = row.tahun1
            var item = this.tableData4[j]
            item.edit = false
            this.$set(this.tableData4, j, item)
          } else {
            this.tableData4.splice(j, 1)
          }
        },
        confirmEdit: function (j, row) {
          this.form1.kode = row.kode
          this.form1.name = row.nama
          // this.dialogFormWilEdit = true
          var item = this.tableData[j]
          item.edit = true
          item.nama1 = item.nama
          this.$set(this.tableData, j, item)
        },
        confirmEdit1: function (row, formName) {
          // this.$refs[formName].validate((valid) => {
          //   if (valid) {
          //     var row = null
          //     for (var i = 0; i < this.tableData.length; i++) {
          //       if (this.tableData[i]['kode'] === this.form1.kode) {
          //         row = i
          //       }
          //     }
          //     this.tableData[row].nama = this.form1.name
          //     this.dialogFormWilEdit = false
          // this.loadingModalEdit = true
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.loadingModal = true
              // var req = {action: 'update', kode: row.kode, nama: row.nama}
              var req = ''
              var action = '/'
              if (row.kode !== '') {
                req = {kode: row.kode, nama: row.nama}
                action += 'update'
              } else {
                req = {nama: row.nama, kode_wilayah: row.kode_wilayah}
                action += 'create'
              }
              var req1 = JSON.stringify(req)

              var url = Vue.cookie.get('url') + '/' + jsonUrl.invoice + action

              Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
                // console.log('response ' + JSON.stringify(response.body))
                // if (response.body.status === "SUCCESS") {}
                if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
                  this.$router.push('/login')
                } else {
                  this.dialogFormWilEdit = false
                  this.getData()
                  this.loadingModalEdit = false
                  this.loadingModal = false
                  this.message = response.body
                  this.dialogFormInfo = true
                }
              }, response => {
                // error callback
                this.dialogFormWilEdit = false
                this.loadingModalEdit = false
                this.loadingModal = false
              })
            } else {
              return false
            }
          })
          //   } else {
          //     return false
          //   }
          // })
        },
        confirmAdd: function (formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              // var item = []
              // item['kode'] = this.form.kode
              // item['nama'] = this.form.name
              // this.tableData.push(item)var req = {action: 'read'}

              this.loadingModalAdd = true
              var tgl = moment(this.tanggal_invoice).format('YYYY-MM-DD')
              var tgl1 = moment(this.tanggal_pengiriman).format('YYYY-MM-DD')
              var req = {kode_toko: this.kode_toko, nomor_invoice: this.form_.nomor_invoice, tanggal_invoice: tgl, tanggal_pengiriman: tgl1, item: this.tableData1, subtotal: this.subtotal, ppn: this.ppn, total: this.total_inv}
              var req1 = JSON.stringify(req)

              var url = Vue.cookie.get('url') + '/' + jsonUrl.invoice + '/create'

              Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
                // console.log('response ' + JSON.stringify(response.body))
                // if (response.body.status === "SUCCESS") {}
                if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
                  this.$router.push('/login')
                } else {
                  this.dialogFormVisible = false
                  this.loadingModalAdd = false
                  this.getData()
                  this.message = response.body
                  this.dialogFormInfo = true
                  this.clearForm()
                }
              }, response => {
                // error callback
                this.dialogFormVisible = false
                this.loadingModalAdd = false
                this.clearForm()
              })
            } else {
              return false
            }
          })
        },
        confirmDel: function (row) {
          this.form1.kode = row.kode
          this.nama = row.nomor_invoice
          this.dialogFormWilDel = true
        },
        confirmDel_: function (row) {
          this.dialogFormWilDel1 = true
          this.nama = row.nama
          this.form1.kode = row.kode
        },
        print: function () {
          var mywindow = window.open('', '_blank')

          mywindow.document.write(this.struk)

          mywindow.document.close() // necessary for IE >= 10
          mywindow.focus() // necessary for IE >= 10*/
        },
        confirmDet1: function (row) {
          this.dialogOprDet = true
          this.loadingModalOprDet = true
          this.tableData7 = []
          this.form1.bulan = row.bulan
          this.form1.tahun = row.tahun

          var req = {kode_toko: this.kode_toko, bulan: row.bulan, tahun: row.tahun}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.invoice1 + '/detail'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModalOprDet = false
              this.title = row.bulan + ' - ' + row.tahun
              this.tableData7 = response.body.data
            }
          }, response => {
            // error callback
            this.loadingModalOprDet = false
          })
        },
        confirmDet2: function (row) {
          this.dialogSumDet = true
          this.loadingModalSumDet = true

          var req = {kode_toko: this.kode_toko, bulan: row.bulan, tahun: row.tahun}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.invoice2 + '/detail'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModalSumDet = false
              this.title1 = row.bulan + ' - ' + row.tahun
              this.tableData8 = response.body.data
            }
          }, response => {
            // error callback
            this.loadingModalSumDet = false
          })
        },
        confirmDet: function (row) {
          this.dialogFormPrintVisible = true
          this.loadingModalPrint = true
          this.nomor_invoice = row.nomor_invoice

          var req = {nomor_invoice: this.nomor_invoice}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.invoice + '/detail'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModalPrint = false
              // this.stok_wilayah = response.body.wilayah
              // this.stok_tanggal = response.body.tanggal.substr(0, 10)
              // this.stok_area = response.body.area
              // this.stok_nomor = response.body.nomor_pb
              // this.stok_toko = response.body.toko
              // this.stok_dibuat_oleh = response.body.dibuat_oleh

              this.tableData1 = response.body.data.slice()
              for (var i = 0; i < this.tableData1.length; i++) {
                this.tableData1[i].no = i + 1
              }

              // this.struk = '<!DOCTYPE html><html><head><style>table {font-family: arial, sans-serif;border-collapse: collapse;width: 100%;}table.fixed { table-layout:fixed; width: 0px;}table.fixed td { overflow: hidden; }td, th {border: 1px solid #dddddd;text-align: left;padding: 8px;}h2 {font-family: arial, sans-serif; margin-left: 8px;}.td1 {border: 0px;}</style></head><body><h2>PERMINTAAN PEMESANAN BARANG</h2><br/><table class="fixed"> <col width="122px" /><col width="600px" /><col width="80px" /><col width="300px" />  <tr><td class="td1">WILAYAH</td><td class="td1">: ' + this.stok_wilayah + '</td> <td class="td1">TANGGAL</td><td class="td1" >: ' + this.stok_tanggal + '</td>  </tr>  <tr><td class="td1">AREA</td><td class="td1" >: ' + this.stok_area + '</td> <td class="td1">NOMOR</td><td class="td1" >: ' + this.stok_nomor + '</td>  </tr>  <tr>    <td class="td1">TOKO</td>    <td class="td1" >: ' + this.stok_toko + '</td>   </tr>  <tr>    <td class="td1">DIBUAT OLEH</td>    <td class="td1" >: ' + this.stok_dibuat_oleh + '</td>   </tr></table><br/><br/><table class="fixed"><col width="80px" /><col width="200px" /><col width="700px" /><col width="200px" />  <tr>    <th>NO</th>    <th>SKU</th>     <th>ITEM</th>    <th>QTY</th>  </tr>'

              // for (var i = 0; i < this.tableData1.length; i++) {
              //   this.tableData1[i].no = i + 1
              //   this.struk += '<tr>    <td>' + this.tableData1[i].no + '</td>    <td>' + this.tableData1[i].sku + '</td>     <td>' + this.tableData1[i].nama + '</td>    <td>' + this.tableData1[i].qty + ' ' + this.tableData1[i].satuan + '</td>  </tr>'
              // }

              // this.struk += '</table></body></html>'
            }
          }, response => {
            // error callback
            this.loadingModalPrint = false
          })
        },
        confirmDel1: function () {
          // var row = null
          // for (var i = 0; i < this.tableData.length; i++) {
          //   if (this.tableData[i]['kode'] === this.form1.kode) {
          //     row = i
          //   }
          // }
          // this.tableData.splice(row, 1)
          this.loadingModalDel = true
          var req = {kode: this.form1.kode}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.invoice + '/delete'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + JSON.stringify(response.body))
            // if (response.body.status === "SUCCESS") {}
            this.dialogFormWilDel = false
            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModalDel = false
              this.getData()
              this.message = response.body
              this.dialogFormInfo = true
            }
          }, response => {
            // error callback
            this.dialogFormWilDel = false
            this.loadingModalDel = false
          })
          // this.dialogFormWilDel = false
        },
        confirmDel2: function () {
          this.loadingModalDel1 = true
          var req = {kode: this.form1.kode}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.invoice1 + '/delete'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + JSON.stringify(response.body))
            // if (response.body.status === "SUCCESS") {}
            this.dialogFormWilDel1 = false
            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModalDel1 = false
              this.getDataOpr()
              this.message = response.body
              this.dialogFormInfo = true
              var row = {bulan: this.form1.bulan, tahun: this.form1.tahun, kode_toko: this.kode_toko}
              this.confirmDet1(row)
            }
          }, response => {
            // error callback
            this.dialogFormWilDel1 = false
            this.loadingModalDel1 = false
          })
          // this.dialogFormWilDel = false
        },
        getData: function () {
          // this.loadingModal = true
          this.tableData = []
          this.tableData1 = []
          this.tableData2 = []
          var c = this.current_page
          var req = {kode_toko: '%'}
          if (this.$route.params.kode !== '+') {
            req = {kode_toko: this.$route.params.kode}
            this.kode_toko = this.$route.params.kode
            this.cari = this.$route.params.nama
          }
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.invoice + '/read'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModal = false
              this.tableData = response.body.data
              for (var i = 0; i < this.tableData.length; i++) {
                this.tableData[i].edit = false
                this.tableData[i].add = false
              }
              var a = 0
              var b = a + this.page_size
              if (b > this.tableData.length) {
                b = this.tableData.length
              }
              for (var j = a; j < b; j++) {
                this.tableData2.push(this.tableData[j])
              }
              this.current_page = c
              this.handleCurrentChange(c)
            }
          }, response => {
            // error callback
            this.loadingModal = false
          })

          this.wilayah = []

          url = Vue.cookie.get('url') + '/' + jsonUrl.barang_toko + '/read'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)

            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.wilayah = response.body.data.slice()
              for (var i = 0; i < this.wilayah.length; i++) {
                this.wilayah[i].kode = this.wilayah[i].kode + ''
              }
            }
          }, response => {
            // error callback
          })
        },
        getDataOpr: function () {
          // this.loadingModal = true
          this.tableData3 = []
          this.tableData4 = []
          var c = this.current_page1
          var req = {kode_toko: '%'}
          if (this.$route.params.kode !== '+') {
            req = {kode_toko: this.$route.params.kode}
            this.kode_toko = this.$route.params.kode
            this.cari = this.$route.params.nama
          }
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.invoice + '/read'

          url = Vue.cookie.get('url') + '/' + jsonUrl.invoice1 + '/read'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModal = false
              this.tableData3 = response.body.data
              for (var i = 0; i < this.tableData3.length; i++) {
                this.tableData3[i].edit = false
                this.tableData3[i].add = false
              }
              var a = 0
              var b = a + this.page_size
              if (b > this.tableData3.length) {
                b = this.tableData3.length
              }
              for (var j = a; j < b; j++) {
                this.tableData4.push(this.tableData3[j])
              }
              this.current_page1 = c
              this.handleCurrentChange1(c)
            }
          }, response => {
            // error callback
            this.loadingModal = false
          })

          url = Vue.cookie.get('url') + '/' + jsonUrl.pengeluaran_bulanan_pilihan + '/read'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModal = false
              this.pengbulpil = response.body
            }
          }, response => {
            // error callback
            this.loadingModal = false
          })
        },
        getDataSum: function () {
          // this.loadingModal = true
          this.tableData5 = []
          this.tableData6 = []
          var c = this.current_page2
          var req = {kode_toko: '%'}
          if (this.$route.params.kode !== '+') {
            req = {kode_toko: this.$route.params.kode}
            this.kode_toko = this.$route.params.kode
            this.cari = this.$route.params.nama
          }
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.invoice2 + '/read'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModal = false
              this.tableData5 = response.body.data
              for (var i = 0; i < this.tableData5.length; i++) {
                this.tableData5[i].edit = false
                this.tableData5[i].add = false
              }
              var a = 0
              var b = a + this.page_size
              if (b > this.tableData5.length) {
                b = this.tableData5.length
              }
              for (var j = a; j < b; j++) {
                this.tableData6.push(this.tableData5[j])
              }
              this.current_page2 = c
              this.handleCurrentChange2(c)
            }
          }, response => {
            // error callback
            this.loadingModal = false
          })
        },
        getData1: function (wil) {
          this.loadingModal = true
          this.tableData = []
          this.tableData1 = []
          var c = this.current_page
          var req = {wilayah: wil}
          if (this.$route.params.kode !== '+') {
            req = {wilayah: this.$route.params.kode}
            this.kode_toko = this.$route.params.kode
          }
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.invoice + '/read'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModal = false
              this.tableData = response.body.data
              for (var i = 0; i < this.tableData.length; i++) {
                this.tableData[i].edit = false
                this.tableData[i].add = false
              }
              var a = 0
              var b = a + this.page_size
              if (b > this.tableData.length) {
                b = this.tableData.length
              }
              for (var j = a; j < b; j++) {
                this.tableData2.push(this.tableData[j])
              }
              this.current_page = c
              this.handleCurrentChange(c)
            }
          }, response => {
            // error callback
            this.loadingModal = false
          })
        }
      },
      mounted () {
        this.loadingModal = true
        this.getData()
        this.getDataOpr()
        this.getDataSum()
      }
    }
</script>

<style scoped>
  .edit-input {
    padding-right: 100px;
  }
  .cancel-btn {
    position: absolute;
    right: 15px;
    top: 10px;
  }
</style>


// WEBPACK FOOTER //
// SalesInv.vue?51e6ab75